import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { serverResponse } from "./validators";

interface IConfirmMsisdnMigrationProps {
  code: string;
  productId: string;
  userId: string;
}

export async function addPromoCode({
  code,
  productId,
  userId,
}: IConfirmMsisdnMigrationProps) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/vouchers/digitals`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      json: {
        code,
        productId,
        userId,
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
